import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import Form from "../../components/StaticPageForm";
import { localizedTextDefaultValue } from "../../constants/localizedTextDefaultValue";
import { useApi } from "../../services/api";
import {
  getContactUs,
  upsertContactUs,
} from "../../services/contactUs/contactUsServices";
import {
  LocalizedText,
  UpdateContactUsDto,
} from "../../services/generated/client";
import styles from "./styles.module.css";

const ContactUsPage = () => {
  const { withErrorHandling } = useApi();
  const [contactUs, setContactUs] = useState<UpdateContactUsDto>({
    paragraph: localizedTextDefaultValue,
    phone: "",
    address: localizedTextDefaultValue,
    termsAndConditions: localizedTextDefaultValue,
    email: "",
    facebook: "",
    whatsapp: "",
    instagram: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [languageEditing, setLanguageEditing] =
    useState<keyof LocalizedText>("ka");

  useEffect(() => {
    const fetchContactUs = async () => {
      try {
        const response = await getContactUs();
        if (response) {
          setContactUs(response);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
    fetchContactUs();
  }, []);

  const handleUpdateContactUs = async (e: FormEvent) => {
    e.preventDefault();

    const {
      paragraph,
      phone,
      address,
      termsAndConditions,
      email,
      facebook,
      whatsapp,
      instagram,
    } = contactUs;

    const newContactUs = await withErrorHandling(async () => {
      await upsertContactUs({
        paragraph,
        phone,
        address,
        termsAndConditions,
        email,
        facebook,
        whatsapp,
        instagram,
      });
    });
    if (newContactUs) {
      setContactUs(newContactUs);
    }
  };

  const handleMultiLanguageInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const id = e.target.id as keyof UpdateContactUsDto;
    const value = e.target.value;

    setContactUs((prev) => ({
      ...prev,
      [id]: {
        ...(prev[id] as LocalizedText),
        [languageEditing]: value,
      },
    }));
  };

  if (isLoading) {
    return <div className={styles.mainContent}>Loading...</div>;
  }

  return (
    <div className={styles.mainContent}>
      <div className={styles.formConteiner}>
        <div className={styles.formWrapper}>
          <LanguageSwitcher
            languageEditing={languageEditing}
            setLanguageEditing={setLanguageEditing}
            inForm={true}
          />
          <Form
            title={"Edit ContactUs"}
            submitLabel={"Update"}
            onSubmit={handleUpdateContactUs}
            isView={false}
            languageEditing={languageEditing}
            fields={[
              {
                id: "paragraph",
                label: `Paragraph ${languageEditing.toUpperCase()}`,
                type: "textarea",
                value:
                  contactUs?.paragraph?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "phone",
                label: "Phone",
                type: "text",
                value: contactUs?.phone || "",
                onChange: (e) =>
                  setContactUs((prev) => ({
                    ...prev,
                    phone: e.target.value,
                  })),
              },
              {
                id: "email",
                label: "Email",
                type: "text",
                value: contactUs?.email || "",
                onChange: (e) =>
                  setContactUs((prev) => ({
                    ...prev,
                    email: e.target.value,
                  })),
              },
              {
                id: "address",
                label: `Address ${languageEditing.toUpperCase()}`,
                type: "text",
                value:
                  contactUs?.address?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "termsAndConditions",
                label: `Terms And Conditions ${languageEditing.toUpperCase()}`,
                type: "textarea",
                value:
                  contactUs?.termsAndConditions?.[
                    languageEditing as keyof LocalizedText
                  ] || "",
                onChange: (e) =>
                  handleMultiLanguageInputChange(
                    e as ChangeEvent<HTMLInputElement>
                  ),
              },
              {
                id: "facebook",
                label: "Facebook",
                type: "text",
                value: contactUs?.facebook || "",
                onChange: (e) =>
                  setContactUs((prev) => ({
                    ...prev,
                    facebook: e.target.value,
                  })),
              },
              {
                id: "whatsapp",
                label: "Whatsapp",
                type: "text",
                value: contactUs?.whatsapp || "",
                onChange: (e) =>
                  setContactUs((prev) => ({
                    ...prev,
                    whatsapp: e.target.value,
                  })),
              },
              {
                id: "instagram",
                label: "Instagram",
                type: "text",
                value: contactUs?.instagram || "",
                onChange: (e) =>
                  setContactUs((prev) => ({
                    ...prev,
                    instagram: e.target.value,
                  })),
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
